/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Customer } from '../models/Customer';
import type { EaseOnChangeLog } from '../models/EaseOnChangeLog';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomersService {

    /**
     * Customer Model ViewSet for exposing customer api actions.
     * @param customerType customer_type
     * @param firstName first_name
     * @param lastName last_name
     * @param email email
     * @param contactNumber contact_number
     * @param ordering Which field to use when ordering the results.
     * @param search A search term.
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @returns any
     * @throws ApiError
     */
    public static customersList(
        customerType?: string,
        firstName?: string,
        lastName?: string,
        email?: string,
        contactNumber?: string,
        ordering?: string,
        search?: string,
        page?: number,
        pageSize?: number,
    ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<Customer>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customers/',
            query: {
                'customer_type': customerType,
                'first_name': firstName,
                'last_name': lastName,
                'email': email,
                'contact_number': contactNumber,
                'ordering': ordering,
                'search': search,
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * Customer Model ViewSet for exposing customer api actions.
     * @param data
     * @returns Customer
     * @throws ApiError
     */
    public static customersCreate(
        data: Customer,
    ): CancelablePromise<Customer> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customers/',
            body: data,
        });
    }

    /**
     * Customer Model ViewSet for exposing customer api actions.
     * @param id A unique integer value identifying this customer.
     * @returns Customer
     * @throws ApiError
     */
    public static customersRead(
        id: number,
    ): CancelablePromise<Customer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Customer Model ViewSet for exposing customer api actions.
     * @param id A unique integer value identifying this customer.
     * @returns any
     * @throws ApiError
     */
    public static customersUpdate(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/customers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Customer Model ViewSet for exposing customer api actions.
     * @param id A unique integer value identifying this customer.
     * @param data
     * @returns Customer
     * @throws ApiError
     */
    public static customersPartialUpdate(
        id: number,
        data: Customer,
    ): CancelablePromise<Customer> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/customers/{id}/',
            path: {
                'id': id,
            },
            body: data,
        });
    }

    /**
     * Customer Model ViewSet for exposing customer api actions.
     * @param id A unique integer value identifying this customer.
     * @returns void
     * @throws ApiError
     */
    public static customersDelete(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/customers/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Get diagnosis suites for device.
     * @param id A unique integer value identifying this customer.
     * @returns EaseOnChangeLog
     * @throws ApiError
     */
    public static customersGetChangeLogs(
        id: number,
    ): CancelablePromise<EaseOnChangeLog> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customers/{id}/change_logs/',
            path: {
                'id': id,
            },
        });
    }

}
